import { render, staticRenderFns } from "./ApprovalDocuments.vue?vue&type=template&id=2fd3e2e9"
import script from "./ApprovalDocuments.vue?vue&type=script&lang=js"
export * from "./ApprovalDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports